import type { OnlyAccountListDto } from '../dto';
import type { OnlyAccountList } from '../models';

export const mapOnlyAccountListToDto = (
  model: OnlyAccountList,
): OnlyAccountListDto => ({
  ...model,
});
